import Vue from 'vue';
import VueRouter from 'vue-router';
import PageBanner from '../components/PageBanner.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/checkout/bag',
    name: 'cart',
    components: {
      default: () => import('../views/Cart.vue'),
      banner: PageBanner,
    },
    props: {
      banner: {
        title: 'Cart'
      }
    }
  },
  {
    path: '/checkout/information',
    name: 'information',
    components: {
      default: () => import('../views/CheckoutInfo.vue'),
      banner: PageBanner,
    },
    props: {
      banner: {
        title: 'Information'
      }
    },
    beforeEnter: (to, from, next) => {
      if (!from.name) {
        next({ name: 'cart' });
      }

      next(store.state.checkout.steps.cart);
    }
  },
  {
    path: '/checkout/shipping',
    name: 'shipping',
    components: {
      default: () => import('../views/Shipping.vue'),
      banner: PageBanner,
    },
    props: {
      banner: {
        title: 'Shipping'
      }
    },
    beforeEnter: (to, from, next) => {
      if (!from.name) {
        next({ name: 'cart' });
      }

      next(store.state.checkout.steps.information);
    }
  },
  {
    path: '/checkout/payment',
    name: 'payment',
    components: {
      default: () => import('../views/Payment.vue'),
      banner: PageBanner,
    },
    props: {
      banner: {
        title: 'Payment'
      }
    },
    beforeEnter: (to, from, next) => {
      if (!from.name) {
        next({ name: 'cart' });
      }

      switch (store.state.checkout.deliveryMethod) {
        case 'shipping':
          next(store.state.checkout.steps.shipping);
          break;
        case 'pickup':
          next(store.state.checkout.steps.information);
          break;
        default:
          next(false);
      }
    }
  },
];

const router = new VueRouter({
  mode: "abstract",
  routes,
  linkActiveClass: 'active',
});

export default router;
